/**
 * @module plugins/vuetify
 * @description This plugin integrates the Vuetify library into Nuxt.
 * @param {Object} nuxtApp - The Nuxt app instance.
 * @returns {void} This function does not have a return value.
 */

import {createVuetify} from 'vuetify'
import {defineNuxtPlugin} from 'nuxt/app'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    ssr: true,
    components,
    directives,
    breakpoint: {},
    icons: {},
    lang: {},
    theme: {
      themes: {
        light: {
          primary: '#002d56',
          accent: '#E91E63'
        },
        dark: {
          primary: '#b030b0',
          accent: '#E91E63'
        }
      }
    }
  })
  nuxtApp.vueApp.use(vuetify)
})
